const feedbackRouter = {
    route: null,
    name: 'FeedbackFolder',
    title: 'Feedback',
    type: 'folder',
    icon: 'iconfont icon-quanxianguanli',
    filePath: '/feedback-ui/',
    order: null,
    inNav: true,
    permission: [],
    children: [
        {
            name: 'alert-ui',
            route: '/feedback-ui/alert-ui',
            title: 'AlertUi',
            type: 'view', // 取 route 为默认加载页
            icon: 'iconfont icon-huiyuanguanli',
            filePath: '/feedback-ui/alert-ui.vue',
            inNav: true,
        },
        {
            name: 'badge-ui',
            route: '/feedback-ui/badge-ui',
            title: 'BadgeUi',
            type: 'view', // 取 route 为默认加载页
            icon: 'iconfont icon-huiyuanguanli',
            filePath: '/feedback-ui/badge-ui.vue',
            inNav: true,
        },
        {
            name: 'drawer-ui',
            route: '/feedback-ui/drawer-ui',
            title: 'DrawerUi',
            type: 'view', // 取 route 为默认加载页
            icon: 'iconfont icon-huiyuanguanli',
            filePath: '/feedback-ui/drawer-ui.vue',
            inNav: true,
        },
        {
            name: 'empty-ui',
            route: '/feedback-ui/empty-ui',
            title: 'EmptyUi',
            type: 'view', // 取 route 为默认加载页
            icon: 'iconfont icon-huiyuanguanli',
            filePath: '/feedback-ui/empty-ui.vue',
            inNav: true,
        },
        {
            name: 'message-ui',
            route: '/feedback-ui/message-ui',
            title: 'MessageUi',
            type: 'view', // 取 route 为默认加载页
            icon: 'iconfont icon-huiyuanguanli',
            filePath: '/feedback-ui/message-ui.vue',
            inNav: true,
        },
        {
            name: 'notice-ui',
            route: '/feedback-ui/notice-ui',
            title: 'NoticeUi',
            type: 'view', // 取 route 为默认加载页
            icon: 'iconfont icon-huiyuanguanli',
            filePath: '/feedback-ui/notice-ui.vue',
            inNav: true,
        },
        {
            name: 'modal-ui',
            route: '/feedback-ui/modal-ui',
            title: 'ModalUi',
            type: 'view', // 取 route 为默认加载页
            icon: 'iconfont icon-huiyuanguanli',
            filePath: '/feedback-ui/modal-ui.vue',
            inNav: true,
        },
        {
            name: 'poptip-ui',
            route: '/feedback-ui/poptip-ui',
            title: 'PoptipUi',
            type: 'view', // 取 route 为默认加载页
            icon: 'iconfont icon-huiyuanguanli',
            filePath: '/feedback-ui/poptip-ui.vue',
            inNav: true,
        },
        {
            name: 'popconfirm-ui',
            route: '/feedback-ui/popconfirm-ui',
            title: 'PopconfirmUi',
            type: 'view', // 取 route 为默认加载页
            icon: 'iconfont icon-huiyuanguanli',
            filePath: '/feedback-ui/popconfirm-ui.vue',
            inNav: true,
        },
        {
            name: 'rate-ui',
            route: '/feedback-ui/rate-ui',
            title: 'RateUi',
            type: 'view', // 取 route 为默认加载页
            icon: 'iconfont icon-huiyuanguanli',
            filePath: '/feedback-ui/rate-ui.vue',
            inNav: true,
        },
        {
            name: 'skeleton-ui',
            route: '/feedback-ui/skeleton-ui',
            title: 'SkeletonUi',
            type: 'view', // 取 route 为默认加载页
            icon: 'iconfont icon-huiyuanguanli',
            filePath: '/feedback-ui/skeleton-ui.vue',
            inNav: true,
        },
        {
            name: 'spin-ui',
            route: '/feedback-ui/spin-ui',
            title: 'SpinUi',
            type: 'view', // 取 route 为默认加载页
            icon: 'iconfont icon-huiyuanguanli',
            filePath: '/feedback-ui/spin-ui.vue',
            inNav: true,
        },
        {
            name: 'progress-ui',
            route: '/feedback-ui/progress-ui',
            title: 'ProgressUi',
            type: 'view', // 取 route 为默认加载页
            icon: 'iconfont icon-huiyuanguanli',
            filePath: '/feedback-ui/progress-ui.vue',
            inNav: true,
        },
        {
            name: 'loading-ui',
            route: '/feedback-ui/loading-ui',
            title: 'LoadingUi',
            type: 'view', // 取 route 为默认加载页
            icon: 'iconfont icon-huiyuanguanli',
            filePath: '/feedback-ui/loading-ui.vue',
            inNav: true,
        },
        {
            name: 'tag-ui',
            route: '/feedback-ui/tag-ui',
            title: 'TagUi',
            type: 'view', // 取 route 为默认加载页
            icon: 'iconfont icon-huiyuanguanli',
            filePath: '/feedback-ui/tag-ui.vue',
            inNav: true,
        },
        {
            name: 'tooltip-ui',
            route: '/feedback-ui/tooltip-ui',
            title: 'TooltipUi',
            type: 'view', // 取 route 为默认加载页
            icon: 'iconfont icon-huiyuanguanli',
            filePath: '/feedback-ui/tooltip-ui.vue',
            inNav: true,
        },
    ]
}

export default feedbackRouter